import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { isDuplicateQuestion } from './utils';
function getQuestionTopicListQuery(ancestorID) {
    return db.qnaNode
        .where('ancestors')
        .equals(ancestorID)
        .and(node => {
        const isQuestionType = [NodeType.WRITTEN_QUESTION, NodeType.ORALS_QUESTION].includes(node.type);
        return isQuestionType && !node.deleted && !isDuplicateQuestion(node);
    });
}
export const getQuestionTopicList = async (userID, ancestorID) => {
    const query = getQuestionTopicListQuery(ancestorID);
    // Get all questions for this ancestor, filtering out duplicates in the query
    const questions = await query.toArray();
    // Extract all unique topics
    const topicMap = new Map();
    let othersTopicCount = 0;
    questions.forEach(question => {
        if (question.data.topics.length === 0) {
            othersTopicCount++;
            return;
        }
        const topics = question.data.topics || [];
        topics.forEach(topic => {
            topicMap.set(topic, (topicMap.get(topic) || 0) + 1);
        });
    });
    // Convert to list format
    const topicList = Array.from(topicMap.entries()).map(([topic, count]) => ({
        id: topic,
        title: topic,
        questionCount: count,
    }))
        .sort((a, b) => a.title.localeCompare(b.title));
    return othersTopicCount > 0 ? {
        list: [
            ...topicList,
            {
                id: 'others',
                title: 'others',
                questionCount: othersTopicCount,
            }
        ],
        totalCount: topicList.length + 1,
    } : {
        list: topicList,
        totalCount: topicList.length,
    };
};
